import BigNumber from "bignumber.js";
import { sharePublishReplay, swalloError } from "ngx-libs";
import { Observable, timer } from "rxjs";
import { map, switchMap,  tap } from "rxjs/operators";
import OptionPricerAbi from "src/app/abi/option-pricer";
import { AccountService } from "../services/account.service";
import { ContractService } from "../services/contract.service";
import { EthWalletService } from "../services/eth-wallet.service";
import { Base } from "./base";
import { Market } from "./market";

export class OptionPricer extends Base {
  private sqrtTs: Map<number, Observable<BigNumber>> = new Map();
  private pvs: Map<number, Observable<BigNumber>> = new Map();

  constructor(
    protected contract: string,
    protected accountService: AccountService,
    protected contractService: ContractService,
    private ethWalletService: EthWalletService,
    private market: Market
  ) {
    super(contract, OptionPricerAbi, accountService,contractService);
  }

  getSqrtTsCache(expiry: number) {
    if (!this.sqrtTs.has(expiry)) {
      this.sqrtTs.set(expiry, timer(0, 300000).pipe(
        switchMap(() => this.getSqrtTs(expiry).pipe(swalloError())),
        tap((v) => {
          this.market.contractVault.optionPricer.blackScholesLookup.sqrtTs[expiry] = v.toDecimal();
        }),
        sharePublishReplay(1)
      ));
    }
    return this.sqrtTs.get(expiry);
  }

  getPvsCache(expiry: number) {
    if (!this.pvs.has(expiry)) {
      this.pvs.set(expiry, timer(0, 300000).pipe(
        switchMap(() => this.getPvs(expiry).pipe(swalloError())),
        sharePublishReplay(1)
      ));
    }
    return this.pvs.get(expiry).pipe(
      tap((v) => {
        this.market.contractVault.optionPricer.blackScholesLookup.pvs[expiry] = v.toDecimal();
      })
    );
  }

  getSqrtTs(expiry: number) {
    return this.call((i) => i.methods.sqrtTs(expiry)).pipe(map((v) => new BigNumber(v).fromDecimal()));
  }

  getPvs(expiry: number) {
    return this.call((i) => i.methods.pvs(expiry)).pipe(map((v) => new BigNumber(v).fromDecimal()));
  }
}
